import styled from 'styled-components';

const SectionRegisterPage = styled.section``;

export default SectionRegisterPage;
